module.exports = __webpack_public_path__ + "static/img/Matt-Hill.fafdf5e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Matt-Hill.jpg
// module id = lcob
// module chunks = 0